
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status2FA"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registerIp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promocodes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bonusSlot"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bonusCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bonusAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"purseType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mainPurseTypeWithdrawAmountToday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partnerType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partnerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"moneyRain"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chatPrises"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"depositCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"withdrawsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"withdrawsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxBet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ngr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"betsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"depositWagering"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statusReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manualTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialAccounts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vk"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"steam"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telegram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"google"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"balance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purseType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bonus"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":778}};
    doc.loc.source = {"body":"query getUserInfo($userId: Float!) {\n  getUserInfo(userId: $userId) {\n    userId\n    username\n    role\n    createdAt\n    email\n    emailVerified\n    mobilePhone\n    status2FA\n    registerIp\n    promocodes\n    bonusSlot\n    bonusCount\n    bonusAmount\n    purseType\n    timezone\n    mainPurseTypeWithdrawAmountToday\n    leadId\n    partnerType\n    partnerId\n    meta\n    moneyRain\n    chatPrises\n    depositCount\n    depositAmount\n    withdrawsCount\n    withdrawsAmount\n    maxBet\n    ngr\n    betsAmount\n    depositWagering\n    status\n    statusReason\n    tags {\n      manualTags {\n        id\n        name\n        category\n      }\n    }\n    socialAccounts {\n      vk\n      steam\n      telegram\n      google\n    },\n    balance {\n      purseType\n      amount\n      bonus\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getUserInfo"] = oneQuery(doc, "getUserInfo");
        
